import { Component, Vue } from 'vue-property-decorator';

@Component
export class ValidationFormMixin extends Vue {
  public getValidationState({ dirty, validated, valid = null }: any): void {
    return dirty || validated ? valid : null;
  }

  public async validation(): Promise<boolean> {
    const isValid = await this.validateForm()
    console.log('validation', isValid)
    return isValid
  }

  public async validateForm (): Promise<boolean> {
    return await (this.$refs.observer as any).validate();
  }
}
